import { ContentType } from '@entries/content-types'
import Review from '@entries/contentful-review'
import { withDisplayName } from '@hocs/with-display-name'
import { groupBy } from '@utils/utils'
import { graphql } from 'gatsby'
import React, { Fragment, useMemo } from 'react'

// Todo same graphql fragment from Review component ?
const ContentfulPageSectionStars: Utils.EntryFC<
  Queries.ContentfulPageSectionStarsFragment
> = ({ content: { contents }, entryInspectorProps, fieldInspectorProps }) => {
  const groupedReviews = useMemo(
    () =>
      groupBy(
        contents.filter(
          (content) => content.__typename === ContentType.ContentfulReview
        ),
        'category'
      ),
    [contents]
  )

  return (
    <div
      className="relative max-h-[600px] w-full max-w-full overflow-auto bg-background-default laptop:max-h-none"
      {...entryInspectorProps()}
    >
      <div className="hidden px-4 laptop:block">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-1">Label</div>
          <div className="col-span-3">Libellé et Code ISIN</div>
          <div className="col-span-3">Société de gestion</div>
          <div className="col-span-2">
            Notation <span className="whitespace-nowrap">Morningstar ™</span>
          </div>
          <div className="col-span-3">Commentaires</div>
        </div>
      </div>
      <ul
        {...fieldInspectorProps({
          fieldId: 'contents',
        })}
      >
        {Object.entries(groupedReviews).map(([group, reviews]) => (
          <Fragment key={`section-${group}`}>
            <li className="bg-theme-default-accent2 px-4">
              <span className="text-085 font-medium leading-alternate text-grey-300">
                {group}
              </span>
            </li>
            {reviews.map((review) => (
              <li
                key={`item-${group}-${review.id}`}
                className="border-b border-solid border-b-theme-default-accent2"
              >
                <Review content={review} />
              </li>
            ))}
          </Fragment>
        ))}
      </ul>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageSectionStars on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulReview
      ... on Contentful4VKja7XjbWkW4WeI4OqeUi {
        category
      }
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionStars,
  'ContentfulPageSectionStars'
)
